export default __webpack_public_path__ + "static/media/Pickpocket's Leggings of the Deceiver.749cbeac.jpg";